import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/693bcda5e534c90014a57c10/gencarbon_esg/src/app/billion-dollar-secret-sauce-opportunities/components/BillionDollarInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/693bcda5e534c90014a57c10/gencarbon_esg/src/components/common/Header.tsx");
